import { WhiteBox } from '../../../../../../baseComponents/AppLayout/WhiteBox'
import { BigTitleAndRightLayout } from '../../../../../../baseComponents/Layout/TitleAndRightLayout'
import TwinTableCard, { RenderTwinTableCards } from '../../../../../../baseComponents/TwinTable/TwinTableCard'
import { SearchBarTable } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getBasePath } from '../../../../../../utils/globals/link'
import { stringMatchWithSearch } from '../../../../../../utils/globals/search'
import { faPlus, faUser } from '@fortawesome/pro-light-svg-icons'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { TaskCFieldModelType } from '@teinor/erp/types/company/task/taskCField'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import ModalTaskCFieldsFlow from './ModalTaskCustomFieldsFlow'
import { getSingleEmployeeParam } from '../../../../../../utils/reducers/getters'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

interface TaskCustomFieldsTypeModelTypeExt extends TaskCFieldModelType {
    checked?: boolean
    order: number
}
type RenderByTaskFields = {
    myFavouriteTaskFields: JSX.Element[]
    myTaskFields: JSX.Element[]
}
interface TaskCFieldStatusesFlowProps {}

const TaskCFieldTypesStatusesFlow: React.FC<TaskCFieldStatusesFlowProps> = () => {
    const location = useLocation().pathname
    const { t } = useTwinTranslation()
    const { data, generalSearch, setGeneralSearch, openModal, setOpenModal, getData } = useTaskFlowLogic()
    const basePath = getBasePath(location, 'taskFlow')
    const renderThisJSON: RenderByTaskFields = {
        myFavouriteTaskFields: [],
        myTaskFields: []
    }

    for (const element of data) {
        const includesSearch = stringMatchWithSearch(generalSearch, element?.name)
        if (includesSearch) {
            const elementJSX = <TwinTableCard key={element.id} id={String(element.id)} title={element?.name || ''} img={'/no-image-small.png'} icon={faUser} lastPath='main' {...{ basePath }} />
            if (element.checked) {
                renderThisJSON.myFavouriteTaskFields.push(elementJSX)
            } else {
                renderThisJSON.myTaskFields.push(elementJSX)
            }
        }
    }

    return (
        <BigTitleAndRightLayout title={t('boards', 'Tableros')}>
            <WhiteBox className='flex flex-col flex-auto px-40 py-50'>
                <div className='flex flex-col flex-auto'>
                    <div className='flex justify-between items-center flex-wrap gap-15 mb-20'>
                        <SearchBarTable onChange={setGeneralSearch} placeholder={t('searchDots', 'Buscar...')} />
                        <ButtonSecondary onClick={() => setOpenModal({ type: 'edit', allRowData: {} })}><TwinIcon icon={faPlus} className='mr-8'></TwinIcon><TwinTrans transKey={'configureFavorites'}>Configurar favoritos</TwinTrans></ButtonSecondary>
                    </div>
                    <div className='flex-auto h-1 overflow-auto'>
                        <RenderTwinTableCards title={t('myFavouriteBoards', 'Mis tableros favoritos')} twinTableCards={renderThisJSON.myFavouriteTaskFields} />
                        <RenderTwinTableCards title={t('otherBoards', 'Otros tableros')} twinTableCards={renderThisJSON.myTaskFields} className='mt-20' />
                    </div>
                </div>
            </WhiteBox>
            {openModal?.type === 'edit' ? <ModalTaskCFieldsFlow setOpened={() => setOpenModal(null)} onSubmit={getData} TaskCFieldsTypes={data} /> : null}
        </BigTitleAndRightLayout>
    )
}

const useTaskFlowLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [data, setData] = useState<TaskCustomFieldsTypeModelTypeExt[]>([])
    const [generalSearch, setGeneralSearch] = useState<string>('')

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/task/customField/getAllTaskCFields', {})

        if (result) {
            const parameter = getSingleEmployeeParam('task_board_custom_field')
            let parsedParameter = JSON.parse(parameter || '{}')
            for (const item of result) {
                const idStr = String(item.id)
                if (parsedParameter[idStr]) {
                    item.checked = true
                    item.order = parseInt(parsedParameter[idStr])
                } else {
                    item.checked = false
                }
            }
            setData(result.sort((a: TwinDictionary, b: TwinDictionary) => (a.order || Infinity) - (b.order || Infinity)))
        }
    }, [setData])

    useEffect(() => {
        getData()
    }, [getData])

    return { data, generalSearch, setGeneralSearch, openModal, setOpenModal, getData }
}

export default TaskCFieldTypesStatusesFlow